import { featureItems } from '@/mocks/home';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
          <i className="ri-star-line text-primary-500 mr-2"></i>
          平台特色
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 transition-all duration-300 hover:border-primary-200 hover:bg-background-50 cursor-pointer text-center lg:text-left"
            >
              <span className="w-11 h-11 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl text-xl mb-4 mx-auto lg:mx-0">
                <i className={item.icon}></i>
              </span>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}